import React from "react";

interface TimelineItemProps {
  text: { [key: string]: string };
  lang: string; // e.g., 'mk' or 'eng'
  isLast?: boolean;
}

const TimelineItem: React.FC<TimelineItemProps> = ({ text, lang, isLast }) => {
  return (
    <div className="flex gap-5">
      {/* Timeline marker & connector line */}
      <div className="flex flex-none flex-col items-center">
        <span className="mt-1 flex h-5 w-5 items-center justify-center rounded-full bg-brand-400 ring-4 ring-brand-100">
          <span className="h-1.5 w-1.5 rounded-full bg-white" />
        </span>
        {!isLast && (
          <span className="mt-1 w-0.5 flex-grow rounded-full bg-gradient-to-b from-brand-300 to-brand-100" />
        )}
      </div>

      {/* Text content */}
      <div className="flex-1 pb-10">
        <div
          className="prose max-w-none leading-relaxed text-gray-600 text-justify"
          dangerouslySetInnerHTML={{ __html: text[lang] }}
        />
      </div>
    </div>
  );
};

export default TimelineItem;
